import { Colors } from 'assets/colors';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  margin-bottom: 32px;

  .overview-header {
    margin-bottom: 20px;

    h3 {
      font-weight: 700;
      font-size: 20px;
      line-height: 27px;
      color: #1a1f36;
      margin: 0;
    }
  }

  .tiles-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }

  .tile {
    background: #ffffff;
    border: 1px solid #e1e5ec;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    min-height: 120px;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    }

    &--prominent {
      background: var(--tile-accent, ${Colors.primary1});
      border-color: var(--tile-accent, ${Colors.primary1});
      color: #ffffff;
      min-height: 140px;

      .tile-title,
      .tile-date {
        color: rgba(255, 255, 255, 0.9);
      }

      .tile-value {
        color: #ffffff;
        font-size: 28px;
      }

      .tile-info-icon {
        opacity: 0.9;

        path {
          fill: rgba(255, 255, 255, 0.9);
        }
      }
    }
  }

  .tile-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  .tile-title-row {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .tile-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #4f566b;
  }

  .tile-date {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #4f566b;
  }

  .tile-value {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #1f262a;
    margin-top: auto;
  }

  .tile-trend {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    margin-top: 8px;

    &--growth {
      color: #21752b;
    }

    &--decline {
      color: #a84748;
    }
  }

  .tile-trend-icon {
    font-size: 16px;
  }

  .tooltip-box {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:hover .tooltip {
      display: block;
    }
  }

  .tooltip {
    display: none;
    width: 252px;
    max-width: 90vw;
    border-radius: 6px;
    background: #ffffff;
    border: 0.5px solid rgba(118, 118, 118, 0.28);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    position: absolute;
    bottom: 100%;
    opacity: 1;
    top: 32px;
    left: -90px;
    transform: none;
    padding: 14px 12px 10px;
    animation: down-to-up 0.5s;
    z-index: 10;

    &:before {
      content: '';
      width: 10px;
      height: 10px;
      border: 0.5px solid rgba(118, 118, 118, 0.28);
      position: absolute;
      top: 100% !important;
      left: 50%;
      transform: rotate(-134deg) translateY(6px) !important;
      border-bottom: none;
      border-right: none;
      border-radius: 3px 0 0 0;
      background-color: white;
      left: 89px !important;
    }
  }

  .tooltip-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .tooltip-previous span {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #4a5256;
  }
`;
